import { IconProps } from "@/types/icons";
import clsx from "clsx";

export const SupportNoCircle = ({
  width = 40,
  height = 40,
  className,
  decorative = false,
  ariaLabel = "Support",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3273 22.9772H15.922V20.7892C15.922 20.1745 16.1153 19.5372 16.4953 18.8945C16.8833 18.2398 17.27 17.7252 17.6447 17.3625C18.0313 16.9892 18.8447 16.2558 20.0647 15.1838C21.3047 14.0945 22.1713 13.1252 22.638 12.3038C23.1113 11.4732 23.3513 10.2718 23.3513 8.7305C23.3513 6.56917 22.694 4.9985 21.3967 4.05984C20.1153 3.1345 18.2047 2.6665 15.718 2.6665C14.366 2.6665 12.2687 3.0065 9.48065 3.6785L9.33398 3.7145L9.56865 5.31317L10.866 5.00917C13.03 4.49317 14.662 4.2305 15.718 4.2305C17.7633 4.2305 19.2953 4.57317 20.2713 5.2465C21.2273 5.9065 21.7113 7.07984 21.7113 8.7305C21.7113 9.93984 21.4927 10.9145 21.062 11.6305C20.6273 12.3585 19.7967 13.2758 18.5927 14.3558C17.3673 15.4558 16.3713 16.4278 15.6273 17.2478C15.1447 17.8332 14.7953 18.4078 14.59 18.9572C14.386 19.5078 14.282 20.0612 14.282 20.6025C14.282 21.0945 14.2927 22.2505 14.3193 22.8185L14.3273 22.9772ZM16.034 29.4772H14.2073V26.6438H16.034V29.4772Z"
        fill="#0066CC"
      />
    </svg>
  );
};


